module.exports = __webpack_public_path__ + "static/tomsguide-97a781ac3d479b57e6fcfae2a379d680.png";